import { createPortal } from "react-dom"
import { toast } from "react-toastify"
import classNames from "classnames"
import styled from "styled-components"

import { useDenyVendorOrderMutation } from "store/api/vendorApi"
import styles from "assets/scss/index.module.scss"
import { ReactComponent as IconDeny } from "assets/svg/icon-deny.svg"

import getErrorMessage from "utils/getErrorMessage"
import { ModalLayout } from "layouts/ModalLayout"

const IconDenyContainer = styled.span`
  width: 24px;
  height: 24px;
  display: inline-block;
  padding-top: 10px;
  background-color: var(--status-danger-subtle);
  border-radius: 10px;
  width: 40px;
  height: 40px;

  svg {
    path {
      fill: #ef4444;
      stroke: #e17a7a;
    }
  }
`

interface Props {
  orderId: number
  onCancel: () => void
}

export const DenyVendorOrderModal = ({ orderId, onCancel }: Props) => {
  const [triggerDenyVendorOrder, { isLoading }] = useDenyVendorOrderMutation()

  const onSubmit = async (event: React.FormEvent<HTMLElement>) => {
    event.preventDefault()

    try {
      const res = await triggerDenyVendorOrder(orderId)
      const error = getErrorMessage(res?.error)
      if (error) {
        toast.error(error)
      } else {
        toast.success("Order has been successfully denied!")
        onCancel()
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      {createPortal(
        <ModalLayout
          width="450px"
          confirmButtonColor="red"
          isFetching={isLoading}
          confirmButtonText="Deny"
          onConfirm={onSubmit}
          onCancel={onCancel}
        >
          <div className={classNames(styles.modalContent, styles.center)}>
            <IconDenyContainer>
              <IconDeny />
            </IconDenyContainer>
            <h3 className={styles.modalTitle}>Deny order</h3>
            <div className={styles.modalMessage}>Are you sure you want to deny the selected order?</div>
          </div>
        </ModalLayout>,
        document.body,
      )}
    </>
  )
}
